import { observableEvent } from '../_utils/observable-event';

async function updateStoreOnServer({ url, ...params }) {
  const formData = buildFormData(params);

  const response = await fetch(url, {
    method: 'PUT',
    body: formData,
    credentials: 'same-origin',
  });

  handleResponse(response);

  return response;
}

function buildFormData(params) {
  const formData = new FormData();
  const permittedParams = [
    'size',
    'finish',
    'prism_id',
    'soft',
    'item',
    'quantity',
    'option',
  ];

  Object.entries(params).forEach(([key, value]) => {
    if (permittedParams.includes(key)) {
      if (key === 'quantity') {
        formData.append('values[copies]', value);
      } else {
        formData.append(key, value);
      }
    }
  });

  return formData;
}


function handleResponse(response) {
  if (!response.ok) {
    observableEvent.record('grouped-page-action-fail', {
      status: response.status,
      url: response.url.replace(window.location.origin, ''),
    });
  }
}



export { updateStoreOnServer };
